import Header from "@commons/header";
import Table from "@components/table";
import Tab from "@components/tabs";

import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Module } from "@apis/index";
import { RootState } from "@store/index";
import ShapeTable from "./Table";
const ShapeList = () => {
  const { data: modules } = useSelector((state: RootState) => state.modules);

  useEffect(() => {
    Module.list({ state: "modules", params: { isActive: true } });
  }, []);

  const items = modules.map((module) => ({
    label: module.name,
    component: ShapeTable,
    props: { moduleId: module.id },
  }));
  return (
    <>
      <Header title="All Brands" />
      <Tab items={items} fitContent paramKey="module" />
    </>
  );
};

export default ShapeList;
